import(/* webpackMode: "eager", webpackExports: ["ComparisonSection"] */ "/app/apps/web/components/landing/ComparisonSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoRequestSection"] */ "/app/apps/web/components/landing/DemoRequestSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/app/apps/web/components/landing/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroVariantC"] */ "/app/apps/web/components/landing/HeroVariantC.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingFooter"] */ "/app/apps/web/components/landing/LandingFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingHeader"] */ "/app/apps/web/components/landing/LandingHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoBar"] */ "/app/apps/web/components/landing/LogoBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetricsSection"] */ "/app/apps/web/components/landing/MetricsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileAppTeaser"] */ "/app/apps/web/components/landing/MobileAppTeaser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModulesShowcase"] */ "/app/apps/web/components/landing/ModulesShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingSection"] */ "/app/apps/web/components/landing/PricingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProblemStatement"] */ "/app/apps/web/components/landing/ProblemStatement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RoiCalculator"] */ "/app/apps/web/components/landing/RoiCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SecuritySection"] */ "/app/apps/web/components/landing/SecuritySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsSection"] */ "/app/apps/web/components/landing/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/app/apps/web/components/landing/TrustBadges.tsx");
